"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const cardSchema = new mongoose_1.Schema({
    user_id: {
        ref: "User",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    last4: {
        type: String,
        required: true,
    },
    card_type: {
        type: String,
        enum: Object.keys(enum_1.CARD_TYPES),
        required: true,
    },
    exp_month: {
        type: String,
        required: true,
    },
    exp_year: {
        type: String,
        required: true,
    },
    signature: {
        type: String,
        required: false,
    },
    authorization_code: {
        type: String,
        required: true,
    },
    preferred: {
        type: Boolean,
        default: true,
        required: false,
    },
}, { timestamps: true, collection: "cards" });
exports.default = (0, mongoose_1.model)("Card", cardSchema);
